import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack } from '@mui/material';
import HelpTooltip from '../../../components/HelpTooltip';

const AddSectionModal = ({ open, newSectionName, setNewSectionName, onClose, onAdd }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Add New Section</DialogTitle>
    <DialogContent>
      <Stack direction="row" alignItems="center">
        <TextField
          autoFocus
          label="Section Name"
          value={newSectionName}
          onChange={(e) => setNewSectionName(e.target.value)}
          fullWidth
          sx={{ mt: 1 }}
        />
        <HelpTooltip title="Enter a name." />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onAdd} variant="contained">
        Add
      </Button>
    </DialogActions>
  </Dialog>
);

export default AddSectionModal;